import { styled } from "styled-components";

import { ActionButtonItem, EmbedIcon } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { activateModal } from "domains/modal/actions";

const StyledShareIcon = styled(EmbedIcon)`
  width: 28px;
`;

export const EmbedMapActionButton = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const shareHandle = () => dispatch(activateModal({ id: "EmbedMapWidget" }));

  return (
    <ActionButtonItem
      dataTestId="embed-map-button"
      icon={<StyledShareIcon />}
      label={translate("app.widget.embed")}
      onClick={shareHandle}
    />
  );
};
